import { request2 } from "../request2";
import config from '../config';

export const addOffersBatch = (data) => {
  return request2({
      method: 'post',
      url: '/dashboard/transaction',
      params: data,
      // config:{
      //   hideBearer:true,
      //   isPannel:true
      // },
      // axiosConfig:{
      //   baseURL: config.adminPannelURL
      // }
  })
}

export const RegenerateInvoice = (id) => {
	return request2({
		method: 'get',
		url: `/dashboard/regenerateInvoice/${id}`
	})
}
export const cancelOrder = (id) => {
	return request2({
		method: 'post',
		url: `/dashboard/transaction/cancel/${id}`
	})
}

export const updateTransactionStatus = (params) => {
	return request2({
		method: 'post',
		url: '/dashboard/transaction/status',
		params
	})
}

export const updateDeliveryStatus = (params) => {
	return request2({
		method: 'post',
		url: '/dashboard/transaction/deliverystatus',
		params
	})
}
export const updateFinalPaymentAmount = (params) => {
	return request2({
		method: 'post',
		url: '/dashboard/transaction/finalpaymentamount',
		params
	})
}